import { useContext, useState } from 'react';
import FieldContext from '../FieldContext';
import useSelectableFieldTypes from './useSelectableFieldTypes';
import { Select, MenuItem, type SelectChangeEvent } from '@mui/material';
import FormattedMessageWithChallengeNaming from '@/components/FormattedMessageWithChallengeNaming';
import ModelsContext from '../../../../ModelsContext';
import useApi from '@/lib/api/useApi';
import { type EditorFieldWithoutRelations } from '@/lib/types';
import type FieldType from '@/lib/constants/challengeModel/FieldType.enum';
import SelectedModelIdContext from '../../../../SelectedModelIdContext';
import EditorIsReadonlyContext from '@/pages/EditorPage/ChallengeModelsEditor/EditorIsReadonlyContext';

const FieldTypeSelect = () => {
  const api = useApi();

  const [, setModels] = useContext(ModelsContext);
  const selectedModelId = useContext(SelectedModelIdContext);
  const { field } = useContext(FieldContext);

  const [saving, setSaving] = useState(false);

  const handleChange = async (
    e: SelectChangeEvent<FieldType>,
  ): Promise<void> => {
    setSaving(true);

    const updatedField = await api.put<EditorFieldWithoutRelations>(
      `editor/challenge-model/fields/${field!.id}/type`,
      {
        type: e.target.value as FieldType,
      },
    );

    setModels(models => {
      models[selectedModelId].fields[field!.id] = {
        ...models[selectedModelId].fields[field!.id],
        ...updatedField,
      };
    });

    setSaving(false);
  };

  const selectableFieldType = useSelectableFieldTypes();

  const editorIsReadonly = useContext(EditorIsReadonlyContext);

  return (
    <Select
      variant="standard"
      value={field!.type}
      onChange={handleChange}
      disabled={saving || editorIsReadonly}
      fullWidth
    >
      {selectableFieldType.map(fieldType => (
        <MenuItem value={fieldType} key={fieldType}>
          <FormattedMessageWithChallengeNaming
            id={`editor.model_editor.field_editor.type_select.types.${fieldType}`}
          />
        </MenuItem>
      ))}
    </Select>
  );
};

export default FieldTypeSelect;
